import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Segment, Sticky, Grid, Divider } from 'semantic-ui-react';
import { Button, Form, Icon, Modal, Progress, Message } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState } from '../../context';
import { dbCaregivers, dbFamMember } from '../../firebase';
import firebase from 'firebase/app';
import context from '../../context';
import 'firebase/functions';

const Caregiver = ({userr, inst}) => {
  const someContext=useContext(AppState);
  const {
    familyMembers,
    users,
    logged,
    filter,
    setFilter,
    pending,
    filtercaregiver,
    setFilterCaregiver,
    filter2nd,
    setFilter2nd,
    filtermine,
    setFilterMine,
    filterunassigned,
    setFilterunassigned,
    caregivers
  } = someContext;
  const sendText = firebase.functions().httpsCallable('sendText');
  const {userid,bool} = useParams();
  const contextRef = createRef();
  
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [rating, setRating]=useState(5);
  const [existingCaregivers,setCaregivers]=useState([]);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  // const [router,setRouter]=useState(false);

  useEffect(()=>{
    const  initializeFam = (snappy2) =>{
      if(snappy2.val()[userid]){
      setCaregivers(snappy2.val()[userid]["caregivers"])
      console.log(snappy2.val()[userid])
      }
  console.log(userid);
  }
    
    dbFamMember.once('value',initializeFam,error=>alert(error));
    return ()=>{dbFamMember.off('value',initializeFam)}
  }, [userid, users]);

  // useEffect(()=>{
  //   const  initializeFam = (snappy2) =>{
  //     if(snappy2.val()[userid]["seniors"]){
  //     setRouter(true)
  //     console.log(snappy2.val()[userid]["seniors"])
  //     }
  // }
  //   dbFamMember.on('value',initializeFam,error=>alert(error));
  //   return ()=>{dbFamMember.off('value',initializeFam)}
  // }, [userid]);
  
  const [familymembers, setFamilyMembers]=  useState(userid)

  function WriteFirebase(){
    if(!(isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string") && !caregivers[username]){
      setIsModalOpen(true);
      var temppassword=Math.random().toString(36).slice(7);
      console.log(temppassword)
      // console.log()
    
    const constant = {
      firstName: firstName,
      lastName: lastName,
      phone: phone,
      rating: rating,
      familyMembers: familymembers,
      "todolist" : [{time: {'.sv': 'timestamp'}, detail: "Sample Task", "status":false, sample:true}],
      password : password,
      "notes":"null"

    }
    const dataToPush = {
      [username]: constant
    }
    //var k = dbFamMember.push(dataToPush);

    dbCaregivers.update(dataToPush).catch(err=>console.log(err));
    
    dbCaregivers.child(username).update({id:username}).catch(err=>console.log(err))
    if(existingCaregivers){
      var temp=existingCaregivers
      temp.push(username)
      setCaregivers(temp)}
      else{temp=[username]}

    dbFamMember.child(userid).update({caregivers: temp}).catch(err=>console.log(err))
    dbFamMember.child(userid).update({'careBool': true}).catch(err=>console.log(err))

    reboot()
    // sendText({data: {to: phone, body: 
    //   `You've been added as a caregiver to Homecare! Please go to https://thefinalhomecare.web.app/caregivers with the following credentials.\n Username: ${username} \n Password:${temppassword}` }});
  }
  else{
   if(caregivers[username]){
    alert("Try another username please!")
   } 
   else{
    alert("Make sure you've entered valid information!")
   }
  }
  const isValid=()=>{
    console.log("this is the outcome bro")
    var x=(!isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string")
    console.log(x)
    console.log(typeof(firstName)=="string")
    console.log(typeof(lastName)=="string")
    console.log(!isNaN(Number(phone)))
    return (x)
   
   }

  }
  function reboot(){
    setFirstName("")
    setLastName("")
    setPhone("")
  }
  const PageHeader = () => {
    var heade = inst ? inst : "Homecare";
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              // as={(!isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string") ? Link : Button}
              // to={(!isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string") ? "/" : ""}
              inverted
              content={heade}
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };


  return (
    <div ref={contextRef}>
      
        <PageHeader />
        <Sticky context={contextRef} >
        <Grid textAlign='center' style={{ height: '10vh' }} padded>
        {/* <Grid.Row>
            <Grid.Column style={{marginLeft:"30px", marginRight:"30px"}}>
            <Progress percent={50} indicating />
            </Grid.Column>
            </Grid.Row> */}
            
       
        <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
          <Header icon='checkmark' content='Complete!' />
          <Modal.Content>
      <p>
              A text has been sent to your caregiver with their username and password!
      </p>
          </Modal.Content>
          <Modal.Actions>
      <Button color='green' inverted  onClick={()=>setIsModalOpen(false)}>
              <Icon name='pen square' /> Add Another
      </Button>
      <Button color='green' inverted as={Link} to={bool==1 ? `/familymembers/profile/${userid}`: !inst ? `/familymembers/register/senior/${userid}/${bool}` : `/${inst}/familymembers/register/senior/${userid}/${bool}`}> 
      {/* {router ? `/familymembers/profile/${userid}` :} */}
              <Icon name='checkmark' /> Continue
      </Button>
          </Modal.Actions>
        </Modal>
            

          {/* <Grid.Row>
            <Form size="large" >
              <Form.Group widths='equal'  style={{marginTop:"10px"}}>
                <Form.Input

                required={true}
                  onChange={(e) => { setFirstName(e.target.value) }}
                  label='Caregiver First Name:'
                  value={firstName}
                />
              </Form.Group>
              <Form.Group  widths='equal'  style={{marginTop:"10px"}}>
              <Form.Input
              required={true}

                  onChange={(e) => { setLastName(e.target.value) }}
                  label='Caregiver Last Name:'
                  value={lastName}
                />
                </Form.Group>
                <Form.Group widths='equal'  style={{marginTop:"10px"}}>
                <Form.Input

                required={true}
                  onChange={(e) => { setUsername(e.target.value) }}
                  label='Username for their account:'
                  value={username}
                />
              </Form.Group>
              <Form.Group widths='equal'  style={{marginTop:"10px"}}>
                <Form.Input

                required={true}
                  onChange={(e) => { setPhone(e.target.value) }}
                  label='Their Number:'
                  value={phone}
                />
              </Form.Group>
        </Form>
        </Grid.Row> */}
          {/* <Grid.Row>
            <Button onClick={() => { console.log("this function is for basically clearing the form.input of medications") }}>
              <Button.Content>
                <Icon name="add circle"></Icon>
                  Add Medication
                </Button.Content>
            </Button>
          </Grid.Row> */}
          {/* <Grid.Row>
            <Grid.Column width={6}>
              <Button circular
                compact
                fluid
                // as={Link}
                // to={"familymembers/register/caregiver"}
                color='green'
                onClick={() => WriteFirebase()}
                icon>
                <Button.Content>
                  <Icon name="long arrow alternate right" size="large"></Icon>
                </Button.Content>
              </Button>
              

            </Grid.Column>
          </Grid.Row> */}
        
          <Divider hidden />
          <Grid.Row>
            <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
            <Progress percent={50} indicating />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h5">
                 Enter Caregiver information:
              </Header>
              <Form size='large' >
                <Segment stacked>
                  <Form.Input
                    required={true}
                    onChange={(e) => { setFirstName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Caregiver First Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setLastName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Caregiver Last Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setPhone(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Phone number'
                  />
                  <Form.Input fluid icon='user' iconPosition='left' onChange={(e) => { setUsername( e.target.value) }} placeholder='Their Username' />
                  <Form.Input fluid icon='key' iconPosition='left' onChange={(e) => { setPassword( e.target.value) }} placeholder='Their Password' />


                  <Button color='teal' fluid size='large' onClick={() => WriteFirebase()} >
                    Continue
        </Button>
                </Segment>
                {/* {error ? <div style={{ maxWidth: 450 }}>
                  <Message
                    warning
                    floating
                    content="This username already exists! Please choose another"
                    size="tiny"
                  />
                </div> : ""} */}
              </Form>
              <Message>
                Your privacy is important to us<a href='/privacy'> Privacy policy</a>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>
     
     
     
      </Sticky>
    </div>
  );
}

export default Caregiver;